import Component 			from '../../colorz/Component';

import device 				from '../../colorz/utils/device';
import getAbsoluteOffset 	from '../../colorz/utils/getAbsoluteOffset';
import getData 				from '../../colorz/utils/getData';

module.exports = class FadeIn extends Component {
	onInit(el) {
		this.onVisible = this.onVisible.bind( this );

		this.el = el;

		this.isVisible 		= false;
		this.isLastVisible 	= false;
		this.isReady 		= false;
		this.marge			= getData( this.el, 'marge' ) ? parseFloat( getData( this.el, 'marge' ) ) : .20 ;
		this.marge 			= 1 - this.marge;
		this.delay			= getData( this.el, 'delay' ) ? parseFloat( getData( this.el, 'delay' ) ) : 0 ;
	}

	onReady() {
		this.onResize();

		setTimeout( ()=> {
			this.onResize();
			this.onScroll();
			this.isReady = true;
		}, 100)
	}

	onResize() {
		this.offset = getAbsoluteOffset( this.el );
	}

	onScroll() {
		if( !this.isReady ) {  return; }

		if( this.offset.top < ( device.scroll.top + device.height * this.marge )  ) {
			this.isVisible = true;
		}


		if( this.isVisible !== this.isLastVisible && this.isVisible ) {
			setTimeout( this.onVisible, this.delay);
		}


		if( !this.isVisible ) {
			setTimeout( this.onScroll, 200);
		}

		this.isLastVisible = this.isVisible;
	}

	onVisible() {
		this.el.classList.add('is-visible');
	}
}